import React, {Component} from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';

import routes from "./routes";

import "bootstrap/dist/css/bootstrap.min.css";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./assets/style.css";

import { appActions } from './core/app'
import { providerActions } from './core/providers'
import { notificationListActions } from "./core/notifications-lists";

import { url_query } from './core/helper'
import PrivateRoute from './PrivateRoute'

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      check_notifiacionts: false
    };
  }

  componentDidUpdate(oldProps,oldState){
    const { user,  authenticated} = this.props
    if ( authenticated &&  oldProps.user.sessionId !== user.sessionId ){
      this.checkNotifications()
    }
  }

  componentWillMount() {
    const { user_token } = this.props
    if(user_token) {
      this.props.loadProvider(user_token)
    }
  }

  componentDidMount() {

   this.timerID = setInterval(
     () => this.checkNotifications(),
     12000
   );
 }

 componentWillUnmount() {
   clearInterval(this.timerID);
 }

 checkNotifications(){
   const { authenticated, loadNotifications, user } = this.props
   if (authenticated)
    this.props.loadNotifications('prestador', user.sessionId)
 }

 render() {
    const { navigateToPath, checked, authenticated, show_menu } = this.props
    return (
      <div>
        <Switch>
          { checked && routes.map((route, index) => {
            return ( route.name !== 'login' && route.name !== 'unauthorized' ? (
              <PrivateRoute authenticated={authenticated} key={index} path={route.path} exact={route.exact} name={route.name} component={ props => {
                  return (
                    <route.layout {...props} show_menu={show_menu} navigateToPath={navigateToPath} >
                      <route.component {...props} navigateToPath={navigateToPath} />
                    </route.layout>
                  );
                } }
              />) : (<Route key={index} path={route.path} exact={route.exact} name={route.name} component={ props => {
                  return (
                    <route.layout {...props} navigateToPath={navigateToPath} >
                      <route.component {...props} navigateToPath={navigateToPath} checked={checked} authenticated={authenticated}  />
                    </route.layout>
                  );
                } }
              />)
            );
          })}
        </Switch>
      </div>
    );
  }
}

App.propTypes = {
  navigateToPath: PropTypes.func.isRequired,
}


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const { session } = state
  //console.log('mapStateToProps->app',state, props, 'show_menu', state.app.get('show_menu'))
  return {
    user_token: url_query().u || null,
    checked: session.checked,
    authenticated: session.authenticated,
    user: state.session.user,
    show_menu: state.app.get('show_menu')
  };
};

const mapDispatchToProps = {
  navigateToPath: appActions.navigateToPath,
  loadProvider: providerActions.loadProvider,
  loadNotifications: notificationListActions.loadNotifications,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);
